import { render } from "./spddxq.vue?vue&type=template&id=65de2a58&scoped=true"
import script from "./spddxq.vue?vue&type=script&lang=js"
export * from "./spddxq.vue?vue&type=script&lang=js"

import "./spddxq.vue?vue&type=style&index=0&id=65de2a58&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65de2a58"]])

export default __exports__